exports.name = 'Model';

exports.types = [
  'string', 'object', 'boolean', 'array', 'number', 'expression', 'date',
  'SimpleModel', 'ListModel', 'TableModel', 'FilterModel', 'TreeModel',
  'reference', 'function'
];

exports.syskeys = [];

exports.fields = {}
